<template>
  <v-dialog v-model="dialog" max-width="800px" scrollable>
    <template #activator="{ on }">
      <v-btn color="primary" v-on="on" depressed tile class="mr-2 my-3 my-md-0">
        <v-icon icon>mdi-image</v-icon>
        Tech. Uploaded Pictures
      </v-btn>
    </template>
    <v-card>
      <v-card-title>Technician Uploaded Pictures</v-card-title>
      <!-- <input type="file" multiple v-on:input="handleFileUpload" > -->
      <input 
            class="d-none"
            multiple
            ref="file"
            type="file"
            @change="handleFileUpload"
            accept="image/*,application/pdf"
        />
      <v-card-text v-if="uploads">
        <v-row>
          <v-col
            v-for="n in uploads"
            :key="n.name"
            class="d-flex child-flex"
            cols="6"
            md="4"
          >
            <v-img
              v-if="n.type && n.type.includes('image') || n.fileName.includes('png') || n.fileName.includes('jpeg')"
              :src="n.url"
              style="cursor: pointer"
              aspect-ratio="1"
              class="grey lighten-2"
              @click="openImage(n)"
            >
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular
                    indeterminate
                    color="grey lighten-5"
                  ></v-progress-circular>
                </v-row>
              </template>
            </v-img>
         <v-card
            v-else
            class="pa-3 grey lighten-2 d-flex flex-column align-center justify-center"
            style="cursor: pointer"
            height="200px"
            @click="openImage(n)"
          >
            <div style="width: 100%; height: 100%; overflow: hidden; position: relative;">
              <iframe 
                :src="n.url" 
                type="application/pdf" 
                style="width: 200%; height: 200%; transform: scale(0.5); transform-origin: top left; border: none; pointer-events: none;"
              ></iframe>
            </div>
            <span class="mt-2 text-center">{{ n.name }}</span>
          </v-card>

           

          </v-col>
          <v-col
            v-for="(n, i) in skeleton"
            :key="i"
            class="d-flex child-flex"
            cols="6"
            md="4"
          >
          <v-img
              v-if="n.type && n.type.includes('image')"
              :src="n.url"
              style="cursor: pointer"
              aspect-ratio="1"
              class="grey lighten-2"
              @click="openImage(n)"
            >
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular
                    indeterminate
                    color="grey lighten-5"
                  ></v-progress-circular>
                </v-row>
              </template>
            </v-img>

            <v-card
              v-else
              class="pa-3 grey lighten-2 d-flex flex-column align-center justify-center"
              style="cursor: pointer"
              height="200px"
              @click="openImage(n)"
            >
              <v-icon large color="red">mdi-file-pdf-box</v-icon>
              <span class="mt-2 text-center">{{ n.name }}</span>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
      <div class="d-flex mt-3 card-action">
            <v-card
              width="100px"
              height="100px"
              class="mr-5 mb-5 cursor-pointer"
              outlined
              @click="$refs.file.click()"
            >
              <v-card-text class="pb-0 d-flex flex-column align-center">
                <img src="../../../assets/add-file.png" width="75px" height="75px" />
                <p class="my-2">Add File</p>
              </v-card-text>
            </v-card>
            <v-card
              width="100px"
              height="100px"
              outlined
              v-for="(file, i) in uploads"
              :key="i"
              class="mr-5 mb-5 cursor-pointer"
            >
              <v-card-text class="pb-0 d-flex flex-column align-center">
                <div class="file-remove" @click.stop="removeFile(i)">
                  <v-btn icon color="red">
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </div>
                <img src="../../../assets/file.png" width="75px" height="75px" />
                <p class="my-2 file-name">
                  {{ file.name }}
                </p>
              </v-card-text>
            </v-card>
         
          </div>
      <div class="close">
        <v-btn color="red" @click="dialog = false" text>     
              <v-icon icon>mdi-close</v-icon>
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { EventBus } from "../../../main";
import { functions } from "../../../assets/js/firebase";
export default {
  props: {
    uploads: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      dialog: false,
      skeleton: []
    };
  },
  methods: {
    openImage({ url }) {
      console.log("Opening image:", url);
      window.open(url, "_blank");
    },
    async handleFileUpload(event) {
        try {
          const vm = this;
          const files = event.target.files;

          let pic = [];

          vm.skeleton = Array(files?.length || 0).fill(0);
          for (let file of files) {
            const base64 = await vm.toBase64(file);
            pic.push({
             base64,
            name: file.name,
            type: file.type, // Add this
            url: base64 
            });
          }

          const doc = {
            pictures: pic,
            id: vm.$route.params,
          };


          const uploadData = functions.httpsCallable("uploadFileTech");
          
          const data = await uploadData(doc);
          vm.skeleton = [];
    
          if (data && data.data.result) {
            vm.uploads.push(...data.data.result);  // Ensure proper array merging
           
            EventBus.$emit("changeImgStatus");
            
           EventBus.$emit("getFilesFromChild", vm.uploads);
          } else {
            console.error("Invalid upload response:", data);
          }
        } catch (error) {
          console.error("Error uploading files:", error);
        }
      },
    removeFile(i) {
      this.uploads.splice(i, 1);
      EventBus.$emit("changeImgStatus");
      EventBus.$emit("getFilesFromChild", this.uploads)
    },
    toBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },
  },
};
</script>

<style>
.card-action{
  overflow-x: auto;
    width: 100%;
    min-height: 130px;
    padding: 0 2rem;
}

.close{
  position: absolute;
  top: 1rem;
  right: 1rem;
}
</style>